<ng-container *ngIf="purchaseItemsNo || requestItemsNo">
  <ng-container *ngIf="purchaseItemsNo && purchaseItemsNo > 0">
    <div data-cy="mb-submit-order-price">
      <div data-cy="mb-submit-order-price-headline">
        <span class="tw-text-lg">{{'mbcart.purchase' | cxTranslate}}</span>
      </div>
      <div class="tw-flex tw-justify-between">
        <div data-cy="mb-submit-order-price-items">
          <span>{{purchaseItemsNo}} {{'submitBox.itemWithS' | cxTranslate}}</span>
        </div>

        <div data-cy="mb-submit-order-price-value">
          <span
            *ngIf="prices?.erpPricingError || (shouldDisplayErpPrices && !prices?.erpTotalListPrice?.formattedValue)">{{'submitBox.orderConfirmation' | mbTranslate}}</span>
          <span *ngIf="!prices?.erpPricingError && shouldDisplayErpPrices && prices?.erpTotalListPrice?.formattedValue"
                [innerHTML]="prices?.erpTotalListPrice?.formattedValue | safeHtml"></span>
          <span
            *ngIf="!prices?.erpPricingError && !shouldDisplayErpPrices && !prices?.totalPrice?.formattedValue && totalPrice?.formattedValue"
            [innerHTML]="totalPrice?.formattedValue | safeHtml"></span>
        </div>
      </div>

      <div class="tw-flex tw-justify-between">
        <ng-container *ngIf="showShippingTaxes && !!prices">
          <ng-container *ngIf="!prices?.erpPricingError && prices?.erpPricesAreCustomerSpecific">
            <div data-cy="mb-submit-order-your-price-heading">
              <span>{{'submitBox.yourPrice' | cxTranslate}}</span>
            </div>
            <div data-cy="mb-submit-order-your-price-value">
              <span [innerHTML]="prices?.erpPrice?.formattedValue | safeHtml"></span>
            </div>
          </ng-container>

          <div data-cy="mb-submit-order-shipment-heading">
            <span>{{'submitBox.shipment' | cxTranslate}}</span>
          </div>
          <div data-cy="mb-submit-order-shipment-value">
            <span *ngIf="prices?.erpPricingError">{{'submitBox.orderConfirmation' | cxTranslate}}</span>
            <span *ngIf="!prices?.erpPricingError" [innerHTML]="prices?.erpFright?.formattedValue | safeHtml"></span>
          </div>

          <div data-cy="mb-submit-order-tax-heading">
            <span>{{'submitBox.taxes' | cxTranslate}}</span>
          </div>
          <div data-cy="mb-submit-order-tax-value">
            <span *ngIf="prices?.erpPricingError">{{'submitBox.orderConfirmation' | cxTranslate}}</span>
            <span *ngIf="!prices?.erpPricingError" [innerHTML]="prices?.erpTaxValue?.formattedValue | safeHtml"></span>
          </div>
        </ng-container>
      </div>

    </div>
  </ng-container>
  <ng-container *ngIf="requestItemsNo && requestItemsNo > 0">
    <div data-cy="mb-submit-order-price-request" class="tw-mt-6">
      <div data-cy="mb-submit-order-request-headline">
        <span class="tw-text-lg">{{'mbcart.request' | cxTranslate}}</span>
      </div>
      <div class="tw-flex tw-justify-between">
      <div data-cy="mb-submit-order-request-items">
        <span>{{requestItemsNo}} {{'submitBox.itemWithS' | cxTranslate}}</span>
      </div>
      <div data-cy="mb-submit-order-request-value">
        <span>{{'mbcommon.priceOnRequest' | cxTranslate}}</span>
      </div>
      </div>
    </div>
  </ng-container>
</ng-container>
